export default {
    preloaded: [],

    spliceIntoChunks(items, chunkSize) {
        return _.chunk(items, chunkSize);
    },

    getCurrentItems() {
        let items = this.groupedItems;

        if (this.filterByTeamId) {
            items = _.filter(items, (image) => image.team_id === this.filterByTeamId);
        }

        return items;
    },

    isMobile() {
        return window.innerWidth <= 640;
    },

    getHeight() {
        const { itemHeight } = this.settings;

        return this.getMobileValue(itemHeight);
    },

    getMaxWidth() {
        const { maxWidth } = this.settings;

        if (typeof maxWidth !== 'object') {
            return maxWidth;
        }

        const isMobileScreen = this.isMobile();

        return isMobileScreen ? maxWidth[0] : maxWidth[1];
    },

    getAmount() {
        const { amount } = this.settings;

        if (typeof amount !== 'object') {
            return parseInt(amount);
        }

        return this.isMobile() ? amount[0] : amount[1];
    },

    getBottomPadding() {
        const bottomPadding = _.get(this.options, 'bottomPadding', 0);

        if (typeof bottomPadding !== 'object') {
            return parseInt(bottomPadding);
        }

        return this.isMobile() ? bottomPadding[0] : bottomPadding[1];
    },

    isDisabled(imageData = null) {
        let disabled = _.get(this.options, 'disabled', false);

        if (typeof _.get(this.options, 'disabled') === 'function') {
            disabled = this.options.disabled(imageData ?? { id: null });
        }

        return disabled;
    },

    checkIfSelected(id) {
        if (typeof _.get(this.options, 'isSelected') === 'function') {
            return this.options.isSelected(id);
        }

        return this.selected.includes(id);
    },

    isFavorited(image) {
        if (typeof _.get(this.options, 'isFavorited') === 'function') {
            return this.options.isFavorited(image);
        }

        return image.favorite ?? false;
    },

    isSaved(image) {
        if (typeof _.get(this.options, 'isSaved') === 'function') {
            return this.options.isSaved(image);
        }

        return image.saved ?? false;
    },

    checkInputSelected(input, data) {
        if (input.checked) {
            this.checkBox(data.element);
            this.selected = [...new Set(this.selected.concat([data.id]))];

            return;
        }

        this.checkBox(data.element, false);
        this.selected = this.selected.filter((id) => id !== data.id);
    },

    checkIfFetching() {
        if (!this.fetching || !_.get(this.options, 'showLoading', false)) {
            return;
        }

        this.checkLoading();
    },

    checkLoading(show = true) {
        this.$el.querySelectorAll('.loading').forEach((element) => {
            element.remove();
        });

        if (!show) {
            return;
        }

        const div = document.createElement('div');

        div.innerText = 'Loading more...';
        div.classList.add(
            'loading',
            'sticky',
            'px-6',
            'rounded-3xl',
            'bg-gray-600',
            'text-white',
            'p-3',
            'mt-3',
            'right-0',
            'bottom-5',
            'z-50',
        );

        div.style.width = '12rem';
        div.style.top = 'calc(100% - 60px)';

        this.$el.appendChild(div);
    },

    checkIfCan(action, item = null, prefix = 'can_') {
        const key = prefix ? `${prefix}${action}` : action;
        const value = _.get(this.options, _.camelCase(key));

        if (typeof value === 'function') {
            return value(item);
        }

        return value;
    },

    prepareItemsWithGroup(assign = true) {
        this.grouped = true;
        const currentItems = this.items ?? [];

        const items = assign ? JSON.parse(JSON.stringify(currentItems)) : currentItems;

        if (!_.get(this.options, 'groupBy')) {
            this.grouped = _.get(this.options, 'label') !== null;
            this.groupedItems = items;

            if (this.grouped) {
                this.groupedItems = _.flatten(_.values(items));
                this.labelQuantity = items.length;
            }

            return;
        }

        let groupedItems = _.groupBy(items, this.options.groupBy);
        const afterGroup = _.get(this.options, 'afterGroup');

        if (afterGroup) {
            groupedItems = afterGroup(groupedItems);
        }

        this.labelQuantity = groupedItems.length;
        this.groupedItems = _.flatten(_.values(groupedItems));
    },

    moveLabels(fragment) {
        fragment.querySelectorAll('.label').forEach((element, index) => {
            const itemHeight = this.getHeight();
            const row = element.previousElementSibling;

            const lastRow = _.last(
                fragment.querySelectorAll(
                    `.vrow[data-label-index="${element.dataset.labelIndex}"]`,
                ),
            );

            let height = parseInt(lastRow?.style.top ?? 0);

            if (index === 0) {
                height += itemHeight + this.settings.gap / 2;
            }

            if (row) {
                let rowTop = parseInt(row.style.top) || 0;
                height = Math.max(0, height - rowTop);
            }

            element.style.height = `${height}px`;
        });
    },

    getLabelHeight() {
        const screenItemsLen = Math.max(1, this.screenItemsLen) / 2;

        return this.grouped ? (this.labelHeight * (this.labelQuantity ?? 1)) / screenItemsLen : 0;
    },

    getLabelsOffset(index) {
        const groupBy = _.get(this.options, 'groupBy');

        if (!groupBy) {
            return this.labelHeight;
        }

        const groupsAbove = _.uniq(
            _.map(this.getCurrentItems().slice(0, index + 1), groupBy),
        ).length;

        return groupsAbove * this.labelHeight;
    },

    checkIfCanSelect(imageData = null) {
        if (!this.isDisabled(imageData)) {
            return;
        }

        this.$nextTick(() => {
            this.$el.querySelectorAll('.box-image:not(.selected)').forEach((box) => {
                box.classList.add('cursor-not-allowed');
            });
        });
    },

    checkIfIsPrintOnly(imageData = null) {
        return this.checkIfCan('printOnly') && imageData?.print_only == true;
    },

    checkIfCanReadyToDownload(imageData = null) {
        return (
            imageData !== null &&
            this.checkIfCan('readyToDownload') &&
            !_.isEmpty(imageData.sent_at) &&
            imageData.print_only === 0
        );
    },

    checkIfCanPrepareToDownload(imageData = null) {
        return (
            imageData !== null &&
            this.checkIfCan('prepareToDownload') &&
            imageData.paid === 1 &&
            imageData.print_only === 0 &&
            imageData.sent_at == null
        );
    },

    calcColumnsAndRows(ofWindow = false) {
        const maxWidth = this.getMaxWidth();
        const itemHeight = this.getHeight();

        let maxHeight = this.$el.clientHeight;
        let clientWidth = this.$el.clientWidth;

        if (ofWindow) {
            clientWidth = window.innerWidth;
            maxHeight = window.innerHeight;
        }

        this.columns = Math.floor(clientWidth / maxWidth);
        this.columns = Math.max(this.settings.minColumns, this.columns);

        this.screenItemsLen = Math.ceil(maxHeight / itemHeight);
        this.cachedItemsLen = this.screenItemsLen * this.settings.amount;
    },

    checkIfInactive(image) {
        const { element } = image;

        if (!element || element === undefined) {
            return;
        }

        const imageBox = element.querySelector('.image-box');
        const img = imageBox?.querySelector('img');
        const svg = imageBox?.querySelector('svg');

        if (this.checkIfCan('inactive', image, null)) {
            element.classList.replace('bg-gray-700', 'bg-gray-300');

            img?.classList.add('opacity-50');
            svg?.classList.add('opacity-0');
        } else {
            element.classList.replace('bg-gray-300', 'bg-gray-700');

            img?.classList.remove('opacity-50');
            svg?.classList.remove('opacity-0');
        }
    },

    dispatchRenderedEvent() {
        this.dispatchEvent('rendered', {
            images: this.items,
            settings: this.settings,
            totalRows: this.totalRows,
            params: _.get(this.options, 'params', {}),
        });
    },

    checkBox(element, checked = true) {
        element.classList.toggle('border-green-500', checked);
        element.classList.toggle('border-transparent', !checked);
    },

    removeLabels() {
        this.$el.querySelectorAll('.label').forEach((element) => {
            element.remove();
        });
    },

    getContainerHeight(containerHeight) {
        let height = _.get(this.options, 'height', containerHeight);

        if (height === 'auto' && this.$refs.container) {
            height = '100%';
            this.$el.classList.add('max-h-full');
        }

        return String(this.getMobileValue(height));
    },

    hasDynamicHeight(height) {
        return /\b(max|available)\b/.test(height);
    },

    getMobileValue(data) {
        if (typeof data !== 'object') {
            return String(data);
        }

        data = data ?? [];

        const isMobileScreen = this.isMobile();
        const isMediumScreen = !isMobileScreen && window.innerWidth <= 786;

        const largeScreenIndex = !isMediumScreen ? data.length - 1 : 1;

        const index = !isMobileScreen ? largeScreenIndex : 0;

        return _.get(data, index, data[0]);
    },

    setOptions({ detail }) {
        this.selected = _.get(detail, 'selected', this.selected);

        if (_.has(detail, 'hasMore')) {
            this.hasMore = detail.hasMore;
        }

        if (_.has(detail, 'colors')) {
            this.options.colors = detail.colors;
        }
    },

    preloadImages(startIndex, finalIndex) {
        const lastLoadedImageIndex = _.findIndex(this.items, ({ id }) => id === undefined);
        const finalIndexImage = (finalIndex + 2) * this.columns;
        const needLoading = Math.max(0, finalIndexImage - lastLoadedImageIndex);

        if (!this.preloaded.includes(finalIndexImage) && needLoading) {
            let params = this.getLoadImagesParams();
            params.offset = startIndex * this.columns;

            this.preloaded.push(finalIndexImage);

            this.fetchImages(params).catch((error) => {
                this.preloaded = this.preloaded.filter((index) => index !== finalIndexImage);
                this.alreadyOffsets = this.alreadyOffsets.filter(
                    (offset) => offset !== params.offset,
                );
            });
        }
    },
};
